(function () {
  function PrinterProgressBar() {
    function progressBarHtml(rowsLength) {
      var html =
        '<div id="batchgeo-print-table-progressbar" class="batchgeo-print-table-progressbar-frame" >' +
        '<div class="table-progressbar-title">Preparing your data for printing</div>' +
        '<div id="table-progressbar-frame" class="table-progressbar-frame">' +
        '<div id="table-progressbar-full" class="table-progressbar-full">' +
        '<div class="table-progressbar-percent"></div>' +
        "</div>" +
        "</div>" +
        '<div class="table-progressbar-info-frame">' +
        '<div class="table-progressbar-info-percent">' +
        '<label class="table-progressbar-info-percent-number">0</label>' +
        '<label class="table-progressbar-info-percent-unit">%</label>' +
        "</div>" +
        '<div class="table-progressbar-info-items">' +
        '<label class="table-progressbar-info-items-thusfar"></label>' +
        '<label class="table-progressbar-info-items-of"> of </label>' +
        '<label class="table-progressbar-info-items-total">' +
        rowsLength.toLocaleString() +
        "</label>" +
        '<label class="table-progressbar-info-items-items"> items</label>' +
        "</div>" +
        "</div>" +
        '<button class="table-progressbar-cancel printer-cancel">Cancel</button>' +
        "</div>";
      return html;
    }

    function progressBarWidth(progress, rowsLength) {
      return Math.round((progress / rowsLength) * 100);
    }

    //cached selectors.
    var $infoFrame;
    var $percentBar;
    var $infoThusfar;
    // var $infoTotal;
    var $percentNumberLabel;
    var $progressBar;

    var rowsLength;

    function updateProgress(rowsRemaining) {
      var progress = rowsLength - rowsRemaining.length;
      var percentDone = progressBarWidth(progress, rowsLength);

      if (!$infoFrame) {
        $infoFrame = $progressBar.find(".table-progressbar-info-frame").eq(0);
      }

      if (!$percentBar) {
        $percentBar = $progressBar.find(".table-progressbar-percent").eq(0);
      }

      if (!$infoThusfar) {
        $infoThusfar = $progressBar
          .find(".table-progressbar-info-items-thusfar")
          .eq(0);
      }

      if (!$percentNumberLabel) {
        $percentNumberLabel = $progressBar
          .find(".table-progressbar-info-percent-number")
          .eq(0);
      }

      // update bar
      $percentNumberLabel.html(percentDone);
      $percentBar.css({ width: percentDone + "%" });
      $infoThusfar.html(progress.toLocaleString());
    }

    /**
     * getProgressBar - description
     *
     * @param   {Number} rowsLength the total amount of rows
     * @returns {jQuery}            The progressBar as a jQuery element.
     */
    function getProgressBar(rowsLength) {
      if ($progressBar) {
        return $progressBar;
      }

      $progressBar = $(progressBarHtml(rowsLength));

      return $progressBar;
    }

    function destroy() {
      if ($progressBar) {
        rowsLength = null;

        $infoFrame = null;
        $percentBar = null;
        $infoThusfar = null;
        // $infoTotal = null;
        $percentNumberLabel = null;

        $progressBar.remove();
        $progressBar = undefined;
      }
      return null;
    }

    function open(rows, onCancel) {
      if (!$progressBar || !$progressBar.length) {
        rowsLength = rows.length;
        $progressBar = getProgressBar(rowsLength);

        $progressBar.find(".table-progressbar-cancel").on("click", function () {
          $progressBar.remove();
          onCancel();
        });

        $("body").append($progressBar);
      }

      return $progressBar;
    }

    return {
      open: open,
      destroy: destroy,
      updateProgress: updateProgress,
    };
  }

  window.PrinterProgressBar = PrinterProgressBar;
})();
